var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"industry main_width m_0"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("1000+")]),_vm._v("\n        个行业品牌都在使用汽修宝 \n    ")]),_vm._v(" "),_c('img',{attrs:{"src":require("../../../static/images2/cooperation_icon.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7da4446","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/industry.vue
// module id = null
// module chunks = 